export default "__VITE_PUBLIC_ASSET__e75af07e__"